import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-page',
  template: `
    <p>
      login-page works!
    </p>
  `,
  styles: []
})
export class LoginPageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
